import { Component, OnInit, HostListener, ViewChild, Inject } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators, FormArray } from "@angular/forms";
import { ReceivingsService } from '@app/services/receivings/receiving.service';
import { MatDialog,MAT_DIALOG_DATA } from '@angular/material/dialog';
import {MatDatepickerModule} from '@angular/material/datepicker';
import { IReceiving } from '@app/models/receiving.interface';
import { Observable, Subscription, filter, map, startWith, take, tap } from 'rxjs';
import { MasterCountCategoryService } from '@app/services/master-count-category/master-count-category.service';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { Store, select } from '@ngrx/store';
import { SubSink } from 'subsink';
import * as ReceivingsActions from '@app/modules/receivings/store/actions/receivings.actions';
import { BreakpointService } from '@app/services/breakpoint/breakpoint.service';
import { LimitAccessService } from '@app/core/services/limit-access.service';
import { TranslateService } from '@ngx-translate/core';
import { lang_selected$ } from '@app/shared/components/language-selector/language-selector.component';
import { ILocation } from '@app/models/location.interface';
import { LocationsService } from '@app/services/locations/locations.service';
import { MatSelectChange } from '@angular/material/select';
import { ProductsService } from '@app/services/products/product.service';
import { selectProductListState } from '@app/modules/products/store/selectors/products.selectors';
import { IProduct } from '@app/models/product.interface';
import { IStorage } from '@app/models/storage.interface';
import * as StoragesActions from '@app/modules/storages/store/actions/storages.actions';
import { selectStoragesPathState } from '@app/modules/storages/store/selectors/storages.selectors';
import { StoragesService } from '@app/services/storages/storage.service';
import * as CoreActions from '@app/core/store/core.action';
import { UserLimitService } from '@app/services/user-limit/user-limit.service';
import { selectProductsState } from '@app/modules/products/store/selectors/products.selectors';
import { ProductAddComponent } from '@app/modules/products/product-add/product-add.component';
import { selectCoreState } from '@app/core/store/core.selectors';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { ToastrService } from 'ngx-toastr';
import { readSerialFailure, readSerialProduct, SerialRefusal } from '@app/shared/components/serial-form/serial-form.component';

@Component({
  selector: 'app-receiving-add',
  templateUrl: './receiving-add.component.html',
  styleUrls: ['./receiving-add.component.scss']
})
export class ReceivingAddComponent implements OnInit {
  readonly separatorKeysCodes = [ENTER, COMMA] as const;
  public form: FormGroup;
  public QytLimitData$: any = 0;
  public products$: IProduct[];
  public receiving: IReceiving;
  public isAllowedToLeave: boolean = true;
  public subs = new SubSink;
  public settings$;
  public currentLocID$;
  public storages$: IStorage[];
  public readReceivingOption: boolean = true;
  public disablePrimaryLocation: boolean = true;
  width_radio_text = '';
  close_button_margin = '';
  lang_selected: string;
  public pageTitle = '';
  public subscription: Subscription;
  public productSearchControl = new FormControl();
  public storageSearchControl = new FormControl();
  public receivingProduct:any;
  filteredProducts: any;
  filteredStorages: any;
  public locations$: ILocation[];
  public storagesLoading: boolean = false;
  public isReceivingTableLoading: boolean = false;
  public searchStarted: boolean = false;
  public parentStorageStructureID : any;
  private manualSet = false;

  // Serialized product: the quantity is the list of serial numbers, never typed.
  public isSerialized = false;
  public serialPatterns: string[] = [];
  public serials: string[] = [];
  public serialsBlocked = false;
  public serialRefused: SerialRefusal[] = [];
  public serialFailed = false;
  public isSaving = false;
  // Bumped on a product change so the serial block starts empty.
  public serialFormKey = 0;

  @HostListener('window:beforeunload')
  canDeactivate(): Observable<boolean> | boolean {
    return this.isAllowedToLeave;
  }
  @ViewChild('autoTrigger') autoTrigger: MatAutocompleteTrigger;

  constructor(
    private fb: FormBuilder,
    private _receivings: ReceivingsService,
    private _matDialog: MatDialog,
    private _master: MasterCountCategoryService,
    private store$: Store,
    private _productService: ProductsService,
    public _translation: TranslateService,
    private _userLimitService: UserLimitService,
    private _breakpoints: BreakpointService,
    private limitAccessService: LimitAccessService,
    private _locations: LocationsService,
    private _receivingService: ReceivingsService,
    private _storageService: StoragesService,
    private _toastr: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.form = this.fb.group({
      quantity: new FormControl('',[Validators.required, Validators.pattern('^[0-9]*$')]),
      storageStructureID: new FormControl('',[Validators.required]),
      prdID: new FormControl('',[Validators.required]),
      expireDate: new FormControl(''),
      locationID: new FormControl(''),
      invoice_number: new FormControl(''),
      po_number: new FormControl(''),
      destinationNote: new FormControl('')
    });

    this.filteredProducts = null; 
    this.filteredStorages = null; 

    //get products list...
    // this._productService.getProductsWithPage('prdNameEn', 'asc', '',0,10).subscribe((data) => {
    //   if(data.products.length>0){
    //     this.filteredProducts = data.products;
    //   }
    // });

    if(this.data?.storageAddItem!=null && this.data?.storageAddItem!=undefined && this.data?.storageAddItem!=''){
      this.pageTitle = this._translation.instant('storages.add.item');
    }
    else{
      this.pageTitle = this._translation.instant('form.receiving.addReceiving');
    }

    if(data && data?.action=='product_receiving'){
      this.isReceivingTableLoading= true;
    }
 

    this.productSearchControl.valueChanges
    .subscribe(value => {

      if (this.manualSet) {
        this.manualSet = false;
        return;
      }

      if(value!=null && value!='' && value.length > 0){
        this._productService.getProductsWithPage('prdNameEn', 'asc', value,0,10, true).subscribe((data) => {
          if(data.products.length>0){
            this.filteredProducts = data.products.map(product => {
              if (product.prdIsSerialized === 1) {
                return {
                  ...product,
                  prdNameEn: `${product.prdNameEn} (${this._translation.instant('product.serialized')})`
                };
              }
              return product;
            });

                this.onSetReceivingProduct();
          }
          else{
            this.filteredProducts = [];
          }
            this.searchStarted = true;
        });
      }
      else {
        return  this._productService.getProductsWithPage('prdNameEn', 'asc', '',0,10, true).subscribe((data) => {
          if(data.products.length>0){
            this.filteredProducts = data.products.map(product => {
              if (product.prdIsSerialized === 1) {
                return {
                  ...product,
                  prdNameEn: `${product.prdNameEn} (${this._translation.instant('product.serialized')})`
                };
              }
              return product;
            });
            this.onSetReceivingProduct();
          }

        });
      }
    })
    //end get products list...

    this.productSearchControl.setValue(this.data?.prdCode);

    this.store$
    .select(selectCoreState)
    .pipe(
      filter((res) => res !== undefined && res !== null), 
      tap(async (res) => {
        this.currentLocID$ = res.me?.locID;
      })
    )
    .subscribe();
    

    //get locations list...
    this._locations.onMyLocations('locName', 'asc').subscribe((res:any) => { 

      this.locations$ = res.data.locations.map(location => {
        return {
          ...location
        };
      });

      if(this.locations$.length>0){
        //this.currentLocID$ = this.locations$[0].locID;
        this._storageService.getStoragesPath(0, this.currentLocID$).subscribe((storages) => {
          if(storages.storages!=null && storages.storages.length>0){
            this.storages$ = storages.storages;
            this.filteredStorages = this.storageSearchControl.valueChanges.pipe(
              startWith(''),
              map(state => state ? this.filterStates(state) : storages.storages.slice())
            );
            this.storageSearchControl.enable();
          }

          if(this.data?.parentStorageStructureID!=null && this.data?.parentStorageStructureID!=undefined && this.data?.parentStorageStructureID!=''){
            this.parentStorageStructureID = this.data.parentStorageStructureID;
            this.storageSearchControl.setValue(this.data.currentAddTitle);
            this.form.get('storageStructureID').setValue(this.data.parentStorageStructureID);
          }

        });
      }
      // if(this.locations$.length>1){
      //   this.storageSearchControl.disable();
      // }

    });
    //end get locations list...

  
    //get storages list...
    // this.storageSearchControl.valueChanges
    // .subscribe(value => {
    //   if(value!=null && value!='' && value.length > 0){
    //     this._productService.getProductsWithPage('prdNameEn', 'asc', value,0,10).subscribe((data) => {
    //       if(data.products.length>0){
    //         this.filteredProducts = data.products;
    //       }
    //       else{
    //         this.filteredProducts = [];
    //       }
    //     });
    //   }
    //   else {
    //     return this._storageService.getStoragesPath(0, this.currentLocID$).subscribe((storages) => {
    //       this.filteredStorages = storages.storages;
    //     });
    //   }
    // })
    //end get storages list...
    



  } 
  
  ngOnInit(): void {

    this.subscription = lang_selected$.subscribe(value => {
      this.lang_selected = value;
      if (this.lang_selected != 'en-ca') {
        this.width_radio_text = 'width_radio_text';
        this.close_button_margin = 'close_button_margin';
      } else {
        this.width_radio_text = '';
        this.close_button_margin = '';
      }
    });

    this.limitAccessService.arraySettingAccess$.subscribe((arraySettingAccess) => {
      if (arraySettingAccess) {
        this.readReceivingOption = this.limitAccessService.getAccess('warehouse', 'receivings', '','');
      }
    });

    this.form.valueChanges.subscribe(() => this.isAllowedToLeave = false);
  }

  ngOnDestroy() {
    this.subs.unsubscribe()
    this.form.reset();
    this.store$.dispatch(ReceivingsActions.resetReceiving());
    this._receivings.onSetIsAllowedToLeave(true);
  }

  onSerialsChange(serials: string[]) {
    this.serials = serials;
    this.form.get('quantity').setValue(serials.length > 0 ? serials.length : '');
  }

  // Serialized receive goes straight to the API so a refused serial list can be shown on the form.
  private submitSerialized() {
    if (this.isSaving || this.serials.length < 1 || this.serialsBlocked) {
      return;
    }
    this.isSaving = true;
    this.serialFailed = false;
    this.form.get('locationID').setValue(this.currentLocID$);
    const payload = { ...this.form.value, quantity: this.serials.length, serialNumbers: this.serials };

    this._receivings.onSave(payload).subscribe({
      next: (response: any) => {
        this.isSaving = false;
        if (response?.result == 'failed.max') {
          this.store$.dispatch(CoreActions.showErrorMessage({
            title: this._translation.instant('errormessage.warning'),
            body: this._translation.instant('errormessage.limitreceiving'),
            show_upgrade: true
          }));
          return;
        }
        if (response?.error) {
          if (response.message) {
            this._toastr.error(this._translation.instant(response.message));
          }
          this.serialFailed = true;
          return;
        }
        this.isAllowedToLeave = true;
        this.store$.dispatch(ReceivingsActions.saveReceivingSuccess(response));
        this._matDialog.closeAll();
      },
      error: (error) => {
        this.isSaving = false;
        const failure = readSerialFailure(error);
        this.serialRefused = failure.refused;
        this.serialFailed = failure.failed;
      }
    });
  }

  async onSubmit() {
    if (this.isSerialized) {
      this.submitSerialized();
      return;
    }
    var item = this.form.get('quantity').value;
    if(item!=null && item!='' && item>0){

      this.isAllowedToLeave = true;
      this.form.get('locationID').setValue(this.currentLocID$);
      

      this.store$.dispatch(ReceivingsActions.saveReceiving({ form: this.form.value }))
      this._matDialog.closeAll();
    }
    else{
      this.store$.dispatch(CoreActions.showErrorMessage({
        title: this._translation.instant('errormessage.warning'),
        body: this._translation.instant('picking.quantitycantbezero'),
        show_upgrade: false
      }));
      return;
    }

  }

  onProductSelection(product: any) {
    // Block asset products from regular receiving
    if(product.prdIsAsset === 1){
      this.productSearchControl.setValue('');
      this.form.get('prdID').setValue('');

      this.store$.dispatch(CoreActions.showErrorMessage({
        title: this._translation.instant('errormessage.warning'),
        body: this._translation.instant('receiving.assetCannotBeReceived'),
        show_upgrade: false
      }));
      return;
    }

    const wasSerialized = this.isSerialized;
    const sameProduct = this.form.get('prdID').value === product.prdID;
    this.isSerialized = product.prdIsSerialized == 1;
    this.form.get('prdID').setValue(product.prdID);

    if (sameProduct && wasSerialized === this.isSerialized) {
      // The same product selected again (autocomplete refresh): keep what was entered.
      return;
    }

    this.serialFormKey++;
    this.serialPatterns = [];
    this.serials = [];
    this.serialsBlocked = false;
    this.serialRefused = [];
    this.serialFailed = false;
    if (this.isSerialized || wasSerialized) {
      this.form.get('quantity').setValue('');
    }

    if(this.isSerialized){
      this._productService.getProduct(product.prdID).subscribe({
        next: (res) => {
          // Ignore a late answer for a product that is no longer selected.
          if (this.form.get('prdID').value === product.prdID) {
            this.serialPatterns = readSerialProduct(res).patterns;
          }
        },
        error: () => { this.serialPatterns = []; }
      });
    }
  }

  onSetReceivingProduct(){
    if(this.data?.prdCode){
      setTimeout(() => {
       const matchedProduct = this.filteredProducts.find(p => p.prdCode === this.data?.prdCode);
       
        if (matchedProduct) {
          this.receivingProduct = matchedProduct;
          this.manualSet = true;
          this.productSearchControl.setValue(matchedProduct.prdNameEn);
          this.onProductSelection(matchedProduct);
          this.autoTrigger?.closePanel();
        }
        this.isReceivingTableLoading = false;
      }, 300);
    }
  }
  onStorageSelection(storageStructureID: any) {
    this.form.get('storageStructureID').setValue(storageStructureID);
  }

  onDateSelected(event: any): void {
    this.form.get('expireDate').setValue(event.value);
  }

  onLocationChange(event: MatSelectChange) {
    this.storagesLoading = true;
    this.storageSearchControl.disable();
    this.form.get('storageStructureID').setValue('');

    this.currentLocID$ = event.value;

    this._storageService.getStoragesPath(0, this.currentLocID$).subscribe((storages) => {
      this.storages$ = storages.storages;

      this.filteredStorages = this.storageSearchControl.valueChanges.pipe(
        startWith(''),
        map(state => state ? this.filterStates(state) : storages.storages.slice())
      );
      
      this.storageSearchControl.enable();
      this.storagesLoading = false;
    });

    this.storageSearchControl.setValue('');
  }

  filterStates(name: any) {
    var names = name;
    if(name?.name!=null && name.name!='undefined'){
      names = name.name;
    }
    // The input mirrors the full storage path ("Floor 1 -> Shelf B"), so a
    // prefix match against the bare name never hits once a node is nested.
    // The list's `path` already ends with the node's own name (a root's path
    // IS its name), so matching anywhere in the path covers both.
    const filterValue = this._normalizeValue(String(names ?? ''));
    return this.storages$.filter(state => this._normalizeValue(String(state.path ?? state.name ?? '')).includes(filterValue));

  }

  noWhitespaceValidator(control) {
    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { 'whitespace': true };
  }
  private _normalizeValue(value: string): string {
    return value.toLowerCase().replace(/\s/g, '');
  }


  async addNewProduct() {
    const limit_status = await this._userLimitService.onGetUserLimitStatus('products');
    
    if(limit_status){

      const dialogRef = this._matDialog.open(ProductAddComponent, {
        data:{
          addFromReceiving: true
        },
         minWidth: '60vw',
         minHeight: '600px',
         maxWidth: '80vw',
         maxHeight: '80vh',
         panelClass: 'ProductAdd__Modal'
       });


       dialogRef.afterClosed().subscribe((res) => {
        if (res?.prdNameEn) {
          
          this.store$
            .select(selectProductsState)
            .pipe(
              take(2),
              filter((state) => state.lastSavedProductId !== 0)
            )
            .subscribe((state) => {
              this.productSearchControl.setValue(res.prdNameEn);
              this.form.get('prdID').setValue(state.lastSavedProductId);
            });
          
        }
      });

     } 
     else{
       
      this.store$.dispatch(CoreActions.showErrorMessage({
         title: this._translation.instant('errormessage.warning'),
         body: this._translation.instant('errormessage.limitproduct'),
         show_upgrade: true
       }));

     }
  }

}
